export class ProductCustomizationState {
    // new
    public CustomizationMethodID: number = 2;
    public allowUpload1: boolean = false;
    public allowUpload2: boolean = false;
    public ProductID: number = -1;
    public ADA: string = '';
    public IsDefaultConfig: boolean = false;
    public th6Enabled: boolean = false;
    public ProductName_Original: string = '';
    public PortalID: number = 0;
    public CDNDomain: string = '';
    public FramePartDomain: string = '';
    public JF_Width: number;
    public JF_Height: number;
    public MouldingThickness: number;
    public lino_is_dyf: boolean = false;
    public image_uploaded: boolean = false;
    public old_true: boolean = false;
    public old_style_composite: string = '';
    public Image_Full: string = '';
    public BackgroundPartURL: string = '';

    // render settings
    public rv_moulding: number;
    public rv_mat1: number;
    public rv_mat2: number;
    public rv_document: number;
    public rv_photo: number;
    public rv_insignia: number;
    public rv_lino: number;

    // old
    public css: PCS_CSS;
    public DPI: number;
    public isHorizontal: boolean = true;
    public state_FlatImageMode: boolean = false;
    public MaxFrameWidthPx: number = 0;
    public MaxFrameHeightPx: number = 50000;
    public UseCommonDPI: boolean = false;
    public UseMaxMouldingForSizing: boolean = false;
    public Padding: number = 0;
    public debug: string = '';
    public FrameDisplay_width: number = 0;
    public FrameDisplay_height: number = 0;

    public Base_DocumentName: string = '';
    public Base_DocumentName2: string = '';
    public Document_Height: number = 0;
    public Document_Width: number = 0;
    public DocumentID: number = 0;
    public DocumentID2: number = 0;
    public Document2_Height: number = 0;
    public Document2_Width: number = 0;

    public BevelWidth: number = 0.0393701;
    public Base_ExtraEntityName: string = '';
    public Base_ExtraID: number = 0;
    public Base_ExtraHeight: number = 0;
    public Base_InsigniaID: number = 0;
    public Base_InsigniaName: string = '';
    public Base_InsigniaWidthInches: number = 0;
    // Insignia 2: the second fixed corner mark of an Icon Founders Edition product (type 92), placed by renderFoundersCorners; never customer selectable
    public Base_Insignia2ID: number = 0;
    public Base_Insignia2Name: string = '';
    public Base_Insignia2WidthInches: number = 0;
    public Base_LinoAdjustmentInches: number = 0;
    public Base_LinoID: number = 0;
    public Base_LinoName: string = '';
    public lino_dyf_color: string = '';
    public DYF_FrameStyleID: number = 0;
    public EngravedPlateID: number = 0;
    public EP_1: string = '';
    public EP_2: string = '';
    public EP_3: string = '';
    public EP_4: string = '';
    public EP_5: string = '';
    public EP_6: string = '';
    public EP_7: string = '';
    public EP_8: string = '';
    public EP_9: string = '';
    public EP_10: string = '';
    public EPBorderType: EPBorderType;
    public EPMethodID: EPMethod;
    public EPSizeType: EPSizeType;
    public EPWidth: number;
    public EPHeight: number;
    public EPContent: string = '';
    public EPTemplate: string = '';
    public EngravedPlateSettings: string = '';
    public EngravedPlateName: string = '';
    public HasEngravedPlate: boolean = false;
    public ItemID: string = '';
    public InsigniaPosition: InsigniaPositionEnum;
    public MatCombo_IsWoodFillet: boolean = false;
    public MouldingExtWidth: number = 0;
    public MouldingName: string = '';
    public MouldingWidthMax: number = 2.125;
    public PrimaryMatColor: string = '';
    public PrimaryMatName: string = '';
    public PrimaryMatID: number = 0;
    public ProductTypeID: number = 0;
    public SecondaryMatColor: string = '';
    public SecondaryMatID: number = 0;
    public SecondaryMatName: string = '';
    // Mat 3: the fixed third, innermost mat of a Dimensions Plus product (type 75), drawn by renderSingleDocFrame between the inner accent and the document; -1 / '' on every other type, never customer selectable
    public Mat3ID: number = -1;
    public Mat3Name: string = '';
    public Mat3Color: string = '';
    // Mat Overlay: the fixed print of a Dimensions Plus product (type 75), a 2048 x 2048 transparent PNG (frame part type 21) drawn by renderSingleDocFrame over the primary mat only; -1 on every other type, never customer selectable
    public MatOverlayID: number = -1;
    public InnerAccentWidth: number = 0.1875;
    public VL_BG_Color: string = '';
    public MouldingID: number = 0;
    public IsCAF: boolean = false;
    public SelectedCategoryMapID: number = -1;
    public o1: string = '';
    public o2: string = '';
    public o3: string = '';
    public o4: string = '';

    public is_uv_print: boolean = false;
    public uv_print_active: boolean = false;
    public uv_lines: UVLine[] = [];
    // Inches the product photo spans, from the UV template's options (photo_width /
    // photo_height); 0 = the frame size + moulding ext width (UVOverlay).
    public uv_photo_w: number = 0;
    public uv_photo_h: number = 0;

    // Old-style (CustomizationMethodID < 2) engraved-plate overlay: inches from the
    // frame center (+X right, +Y down — same coordinate model as UV lines), plus a
    // zoom factor scaling the plate on the old-style photo (1 = actual size). Rendered
    // by EPOverlay in frame-old/frame-none; the >= 2 render path ignores these.
    public ep_xpos: number = 0;
    public ep_ypos: number = 0;
    public ep_zoom: number = 1;
    public ep_show_oldstyle: boolean = false;

    // Second engraved plate: resolved HTML + physical size + its own overlay position
    // (same coordinate model as ep_xpos/ep_ypos/ep_zoom). HasEngravedPlate2 is derived:
    // the plate is attached AND EP2Width > 0 AND there is content. Painted by the second
    // EPOverlay in frame-old/frame-none. Property names are a contract with
    // ImageGenerator2's ReactProductCustomizationState mirror (stack2.cshtml.cs).
    public EP2Content: string = '';
    public EP2Width: number = 0;
    public EP2Height: number = 0;
    public ep2_xpos: number = 0;
    public ep2_ypos: number = 0;
    public ep2_zoom: number = 1;
    public HasEngravedPlate2: boolean = false;
}

// Per-line UV print configuration. Coordinates are in inches relative to the
// horizontal/vertical center of the document/frame (mat is centered around the
// document, so the document center == the frame center). Positive X = right,
// positive Y = down. The text is centered at (x, y).
export interface UVLine {
    x: number;
    y: number;
    fontFamily: string;
    color: string;
    pt: number;
    max_width: number;
    max_height: number;
    text: string;
    // CSS font-weight (400 when missing - the C# copy in ImageGenerator2 may omit it).
    weight?: number;
    // Product page only: shown faintly in place of empty text on a required template
    // (the proof's "Name" / "Date"); never set for headless renders.
    placeholder?: string;
}

export interface PCS_CSS {
    frame_display_width: number;
    frame_display_height: number;

    transparentImg: string;
    pmat_BackgroundImage: string;
    pmat_width: string;
    pmat_height: string;
    pmat_backgroundSize: string;
    pmat_top: string;
    pmat_left: string;
    // Mat Overlay (Dimensions Plus, type 75): #mat_overlay, sized to the primary mat box; hidden with no src on every other frame
    mat_overlay_visible: boolean;
    mat_overlay_src: string;
    mat_overlay_left: string;
    mat_overlay_top: string;
    mat_overlay_width: string;
    mat_overlay_height: string;
    body_width: string;
    body_height: string;
    m_topleft_src: string;
    m_topleft_left: string;
    m_topleft_top: string;
    m_topleft_width: string;
    m_topright_src: string;
    m_topright_left: string;
    m_topright_top: string;
    m_topright_width: string;
    m_bottomright_src: string;
    m_bottomright_left: string;
    m_bottomright_top: string;
    m_bottomright_width: string;
    m_bottomleft_src: string;
    m_bottomleft_left: string;
    m_bottomleft_top: string;
    m_bottomleft_width: string;

    m_left_src: string;
    m_left_left: string;
    m_left_top: string;
    m_left_width: string;
    m_left_height: string;
    m_top_src: string;
    m_top_left: string;
    m_top_top: string;
    m_top_width: string;
    m_top_height: string;
    m_bottom_src: string;
    m_bottom_left: string;
    m_bottom_top: string;
    m_bottom_width: string;
    m_bottom_height: string;
    m_right_src: string;
    m_right_left: string;
    m_right_top: string;
    m_right_width: string;
    m_right_height: string;
    doc1_visible: boolean;
    doc1_src: string;
    doc1_left: string;
    doc1_top: string;
    doc1_width: string;
    doc1_height: string;
    doc1_pmat_bevel_backgroundColor: string;
    doc1_pmat_bevel_left: string;
    doc1_pmat_bevel_top: string;
    doc1_pmat_bevel_width: string;
    doc1_pmat_bevel_height: string;
    doc1_smat_backgroundColor: string;
    doc1_smat_left: string;
    doc1_smat_top: string;
    doc1_smat_width: string;
    doc1_smat_height: string;
    doc1_smat_bevel_backgroundColor: string;
    doc1_smat_bevel_left: string;
    doc1_smat_bevel_top: string;
    doc1_smat_bevel_width: string;
    doc1_smat_bevel_height: string;
    doc1_mat3_backgroundColor: string;
    doc1_mat3_left: string;
    doc1_mat3_top: string;
    doc1_mat3_width: string;
    doc1_mat3_height: string;
    doc1_mat3_bevel_backgroundColor: string;
    doc1_mat3_bevel_left: string;
    doc1_mat3_bevel_top: string;
    doc1_mat3_bevel_width: string;
    doc1_mat3_bevel_height: string;
    doc2_visible: boolean;
    doc2_src: string;
    doc2_left: string;
    doc2_top: string;
    doc2_width: string;
    doc2_height: string;
    doc2_pmat_bevel_backgroundColor: string;
    doc2_pmat_bevel_left: string;
    doc2_pmat_bevel_top: string;
    doc2_pmat_bevel_width: string;
    doc2_pmat_bevel_height: string;
    doc2_smat_backgroundColor: string;
    doc2_smat_left: string;
    doc2_smat_top: string;
    doc2_smat_width: string;
    doc2_smat_height: string;
    doc2_smat_bevel_backgroundColor: string;
    doc2_smat_bevel_left: string;
    doc2_smat_bevel_top: string;
    doc2_smat_bevel_width: string;
    doc2_smat_bevel_height: string;

    fillet_visible: boolean;
    f_container_left: string;
    f_container_top: string;
    f_container_width: string;
    f_container_height: string;
    f_topleft_src: string;
    f_topleft_left: string;
    f_topleft_top: string;
    f_topleft_width: string;
    f_topright_src: string;
    f_topright_left: string;
    f_topright_top: string;
    f_topright_width: string;
    f_bottomright_src: string;
    f_bottomright_left: string;
    f_bottomright_top: string;
    f_bottomright_width: string;
    f_bottomleft_src: string;
    f_bottomleft_left: string;
    f_bottomleft_top: string;
    f_bottomleft_width: string;
    f_left_src: string;
    f_left_left: string;
    f_left_top: string;
    f_left_width: string;
    f_left_height: string;
    f_top_src: string;
    f_top_left: string;
    f_top_top: string;
    f_top_width: string;
    f_top_height: string;
    f_bottom_src: string;
    f_bottom_left: string;
    f_bottom_top: string;
    f_bottom_width: string;
    f_bottom_height: string;
    f_right_src: string;
    f_right_left: string;
    f_right_top: string;
    f_right_width: string;
    f_right_height: string;
    insignia_visible: boolean;
    insignia_bot_visible: boolean;
    insignia_src: string;
    insignia_left: string;
    insignia_top: string;
    insignia_bot: string;
    insignia_width: string;
    insignia_height: string;
    insignia2_visible: boolean;
    insignia2_src: string;
    insignia2_left: string;
    insignia2_top: string;
    insignia2_width: string;
    insignia2_height: string;
    // Icon Founders Edition (type 92): the printed stripe on the rail centre, four boxes in px; hidden on every other frame
    founders_visible: boolean;
    founders_line_bg: string;
    founders_top_left: string;
    founders_top_top: string;
    founders_top_width: string;
    founders_top_height: string;
    founders_right_left: string;
    founders_right_top: string;
    founders_right_width: string;
    founders_right_height: string;
    founders_bottom_left: string;
    founders_bottom_top: string;
    founders_bottom_width: string;
    founders_bottom_height: string;
    founders_left_left: string;
    founders_left_top: string;
    founders_left_width: string;
    founders_left_height: string;
    insignia_br_visible: boolean;
    insignia_br_src: string;
    insignia_br_right: string;
    insignia_br_bot: string;
    insignia_br_width: string;
    insignia_br_height: string;

    lino_visible: boolean;
    lino_src: string;
    lino_left: string;
    lino_top: string;
    lino_width: string;
    lino_height: string;
    ep_visible: boolean;
    ep_bevel_backgroundColor: string;
    ep_bevel_left: string;
    ep_bevel_top: string;
    ep_bevel_width: string;
    ep_bevel_height: string;
    ep_pmat_backgroundImage: string;
    ep_pmat_left: string;
    ep_pmat_top: string;
    ep_pmat_width: string;
    ep_pmat_height: string;
    ep_pmat_border: string;
    ep_smat_width: string;
    ep_smat_height: string;
    ep_backgroundImage: string;
    ep_backgroundSize: string;
    ep_color: string;
    ep_left: string;
    ep_top: string;
    ep_width: string;
    ep_height: string;
    ep_padding: string;
    ep_plateWidthPt: number;
    ep_plateHeightPt: number;
    ep_lines_top: string;
    ep_lines_left: string;
    ep_lines_lineHeight: string;
    ep_lines_fontSize: string;
    ep_lines_width: string;
    ep_lines_height: string;
    tassel_visible: boolean;
    tassel_src: string;
    tassel_left: string;
    tassel_top: string;
    tassel_width: string;
    tassel_height: string;
    tassel_pmat_bevel_backgroundColor: string;
    tassel_pmat_bevel_left: string;
    tassel_pmat_bevel_top: string;
    tassel_pmat_bevel_width: string;
    tassel_pmat_bevel_height: string;
    tassel_smat_backgroundColor: string;
    tassel_smat_left: string;
    tassel_smat_top: string;
    tassel_smat_width: string;
    tassel_smat_height: string;
    tassel_smat_bevel_backgroundColor: string;
    tassel_smat_bevel_left: string;
    tassel_smat_bevel_top: string;
    tassel_smat_bevel_width: string;
    tassel_smat_bevel_height: string;

    varsity_visible: boolean;
    varsity_src: string;
    varsity_left: string;
    varsity_top: string;
    varsity_width: string;
    varsity_height: string;
    varsity_pmat_bevel_backgroundColor: string;
    varsity_pmat_bevel_left: string;
    varsity_pmat_bevel_top: string;
    varsity_pmat_bevel_width: string;
    varsity_pmat_bevel_height: string;
    varsity_smat_backgroundColor: string;
    varsity_smat_left: string;
    varsity_smat_top: string;
    varsity_smat_width: string;
    varsity_smat_height: string;
    varsity_smat_bevel_backgroundColor: string;
    varsity_smat_bevel_left: string;
    varsity_smat_bevel_top: string;
    varsity_smat_bevel_width: string;
    varsity_smat_bevel_height: string;
    varsity_bg_backgroundColor: string;
    varsity_bg_left: string;
    varsity_bg_top: string;
    varsity_bg_width: string;
    varsity_bg_height: string;
    oval_visible: boolean;
    oval_src: string;
    oval_left: string;
    oval_top: string;
    oval_width: string;
    oval_height: string;
    oval_borderRadius: string;
    oval_backgroundColor: string;
    oval_pmat_bevel_backgroundColor: string;
    oval_pmat_bevel_left: string;
    oval_pmat_bevel_top: string;
    oval_pmat_bevel_width: string;
    oval_pmat_bevel_height: string;
    oval_pmat_bevel_borderRadius: string;
    oval_smat_backgroundColor: string;
    oval_smat_left: string;
    oval_smat_top: string;
    oval_smat_width: string;
    oval_smat_height: string;
    oval_smat_borderRadius: string;
    oval_smat_bevel_backgroundColor: string;
    oval_smat_bevel_left: string;
    oval_smat_bevel_top: string;
    oval_smat_bevel_width: string;
    oval_smat_bevel_height: string;
    oval_smat_bevel_borderRadius: string;
    cameo_visible: boolean;
    cameo_src: string;
    cameo_left: string;
    cameo_top: string;
    cameo_width: string;
    cameo_height: string;
    cameo_borderRadius: string;
    cameo_pmat_bevel_backgroundColor: string;
    cameo_pmat_bevel_left: string;
    cameo_pmat_bevel_top: string;
    cameo_pmat_bevel_width: string;
    cameo_pmat_bevel_height: string;
    cameo_pmat_bevel_borderRadius: string;

    spirit_visible: boolean;
    spirit_ins_bot: boolean;
    spirit_visible_lino: boolean;
    spirit_visible_ins: boolean;
    spirit_smat_bg: string;
    spi_left_left: string;
    spi_left_top: string;
    spi_left_width: string;
    spi_left_height: string;
    spi_right_right: string;
    spi_right_top: string;
    spi_right_width: string;
    spi_right_height: string;
    spi_smat_left_left: string;
    spi_smat_left_top: string;
    spi_smat_left_width: string;
    spi_smat_left_height: string;
    spi_smat_right_right: string;
    spi_smat_right_top: string;
    spi_smat_right_width: string;
    spi_smat_right_height: string;
    spi_bot1_left: string;
    spi_bot1_bot: string;
    spi_bot1_width: string;
    spi_bot1_height: string;
    spi_smat_bot1_left: string;
    spi_smat_bot1_bot: string;
    spi_smat_bot1_width: string;
    spi_smat_bot1_height: string;
    spi_bot2_right: string;
    spi_bot2_bot: string;
    spi_bot2_width: string;
    spi_bot2_height: string;
    spi_smat_bot2_right: string;
    spi_smat_bot2_bot: string;
    spi_smat_bot2_width: string;
    spi_smat_bot2_height: string;
    spi_top1_left: string;
    spi_top1_top: string;
    spi_top1_width: string;
    spi_top1_height: string;
    spi_smat_top1_left: string;
    spi_smat_top1_top: string;
    spi_smat_top1_width: string;
    spi_smat_top1_height: string;
    spi_top2_right: string;
    spi_top2_top: string;
    spi_top2_width: string;
    spi_top2_height: string;
    spi_smat_top2_right: string;
    spi_smat_top2_top: string;
    spi_smat_top2_width: string;
    spi_smat_top2_height: string;

    moulding_width: number;
    moulding_half: number;

    double_stack_width: number;
    double_stack_height: number;
    double_stack_aspect_ratio: number;
    double_stack_is_vertical: boolean;

    render_dpi: number;

    uv_line_styles: UVLineCSS[];
}

export interface UVLineCSS {
    visible: boolean;
    left: string;
    top: string;
    width: string;
    height: string;
    fontSize: string;
    fontFamily: string;
    fontWeight: string;
    color: string;
    text: string;
}

export enum EPBorderType {
    Overlay = 1,
    Inset = 2,
    InnerAccent = 3,
}

export enum EPMethod {
    Old = 1,
    Extended = 2,
    Custom = 3,
    SingleDoc = 4,
    Template = 5,
    Admin = 6,
}

/** Rendering and cart behavior treat Admin like Custom. */
export const effectiveEPMethod = (method: EPMethod | number): EPMethod => {
    return method === EPMethod.Admin ? EPMethod.Custom : (method as EPMethod);
};

export const isEPAdmin = (method: EPMethod | number): boolean => {
    return method === EPMethod.Admin;
};

export const isEPCustomLike = (method: EPMethod | number): boolean => {
    return method === EPMethod.Custom || method === EPMethod.Admin;
};

export enum EPSizeType {
    Default = 0,
    AutoSnap = 1,
    Dynamic = 2,
}

export const EP_SNAP_SIZES = [
    {width: 3.0, height: 0.5},
    {width: 3.0, height: 1.0},
    {width: 3.0, height: 2.0},
    {width: 3.5, height: 2.5},
    {width: 4.75, height: 2.75},
    {width: 6.25, height: 1.75},
    {width: 8.125, height: 1.5},
];

export const EP_DEFAULT_FIXED_SIZE = {width: 3, height: 1};

export enum InsigniaPositionEnum {
    Top = 1,
    Bottom = 2,
}

export enum EngravedPlateStatusEnum {
    None = 0,
    Required_Gold = 1,
    Required_Silver = 2,
    Optional_Gold = 3,
    Optional_Silver = 4,
    Optional_Both = 5,
    Required_Black = 6,
    Optional_Black = 7,
}
export enum DYF_FrameStylesEnum {
    None = 0,
    Single_Document = 1,
    Double_Document = 2,
    Tassel = 3,
    Varsity = 4,
    Sports_Oval = 5,
    Portrait_Oval = 6,
    Campus_Scene = 7,
    Cameo = 8,
    Spirit = 9,
    Photo_Frame = 10,
    Century = 11,
    SpiritB = 12,
    DoubleStack = 13,
}

export const renderSettings = {
    referenceDPI: 35,
    topPadding: 7.5,
    defaultPadding: 7.5,
};

// Engraving rule: text on plates shorter than 1" (e.g. the 3" x 0.5" snap size)
// reserves no top/bottom padding but must still keep this much clear of the
// plate's left/right edges. Plates 1" and taller use renderSettings padding.
export const EP_SHORT_PLATE_SIDE_MARGIN_IN = 0.25;

export const DocStackingSizeTiers: DocStackingSizeTiersClass[] = [
    {
        DocSizeTierID: 1,
        CameoRail: 2.875,
        DocDistance: 0.0,
        DocHeight: 5.0,
        DocWidth: 7.0,
        DocOverlap: 0.375,
        OvalRailSide: 2.25,
        OvalRailOvalTop: 1.75,
        OvalRailDocTop: 1.75,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 1.625,
        TasselRailHeight: 3.625,
        TasselRailWidth: 2.5,
        TasselGap: 1.625,
        TasselHeight: 9.75,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 2,
        CameoRail: 2.875,
        DocDistance: 0.0,
        DocHeight: 6.0,
        DocWidth: 8.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 2.25,
        OvalRailDocTop: 2.625,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.625,
        TasselRailHeight: 3.625,
        TasselRailWidth: 2.5,
        TasselGap: 1.625,
        TasselHeight: 9.75,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 3,
        CameoRail: 2.875,
        DocDistance: 0.0,
        DocHeight: 7.0,
        DocWidth: 9.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 2.25,
        OvalRailDocTop: 2.625,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.625,
        TasselRailHeight: 3.125,
        TasselRailWidth: 2.625,
        TasselGap: 1.375,
        TasselHeight: 9.75,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 4,
        CameoRail: 3.125,
        DocDistance: 0.0,
        DocHeight: 8.0,
        DocWidth: 10.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.75,
        OvalRailOvalTop: 3.25,
        OvalRailDocTop: 2.625,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.625,
        TasselRailHeight: 2.875,
        TasselRailWidth: 2.625,
        TasselGap: 1.375,
        TasselHeight: 10.25,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 5,
        CameoRail: 3.1875,
        DocDistance: 0.0,
        DocHeight: 8.5,
        DocWidth: 11.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.6875,
        TasselRailHeight: 2.6875,
        TasselRailWidth: 2.625,
        TasselGap: 1.5,
        TasselHeight: 10.25,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 6,
        CameoRail: 3.1875,
        DocDistance: 0.0,
        DocHeight: 10.0,
        DocWidth: 12.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.6875,
        TasselRailHeight: 2.6875,
        TasselRailWidth: 2.625,
        TasselGap: 1.5,
        TasselHeight: 10.25,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 7,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 11.0,
        DocWidth: 14.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.063,
        TasselRailHeight: 3.063,
        TasselRailWidth: 2.6875,
        TasselGap: 1.625,
        TasselHeight: 10.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 8,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 12.0,
        DocWidth: 16.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.063,
        TasselRailHeight: 3.063,
        TasselRailWidth: 2.75,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 9,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 13.0,
        DocWidth: 17.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.063,
        TasselRailHeight: 3.063,
        TasselRailWidth: 3.0,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 10,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 14.0,
        DocWidth: 17.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.313,
        TasselRailHeight: 3.313,
        TasselRailWidth: 3.25,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 11,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 14.0,
        DocWidth: 18.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.313,
        TasselRailHeight: 3.313,
        TasselRailWidth: 3.25,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 12,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 16.0,
        DocWidth: 20.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.313,
        TasselRailHeight: 3.313,
        TasselRailWidth: 3.25,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
];

export class DocStackingSizeTiersClass {
    public DocSizeTierID: number = 0;
    public CameoRail: number;
    public DocDistance: number = 0;
    public DocHeight: number = 0;
    public DocWidth: number = 0;
    public DocOverlap: number;
    public OvalRailSide: number;
    public OvalRailOvalTop: number;
    public OvalRailDocTop: number;
    public SpiritRailTopAndSides: number;
    public SpiritRailBottom: number;
    public StandardRail: number;
    public TasselRailHeight: number = 0;
    public TasselRailWidth: number = 0;
    public TasselGap: number = 0;
    public TasselHeight: number = 0;
    public TasselWidth: number = 0;
}

export class DefaultPCS {
    public static DefaultBevel: number = 0.0393701;
    public static DefaultDocument: number = 1541; // Cornell
    public static DefaultDocWidth: number = 11;
    public static DefaultDocHeight: number = 8.5;
    public static DefaultInnerAccent: number = 385; // Gold
    public static DefaultInnerAccentWidth: number = 0.1875;
    public static DefaultInsignia: number = 2638; //Cornell Gold
    public static DefaultInsigniaSize: string = `220`;
    public static DefaultInsigniaWidthMax: number = 1.625;
    public static FoundersStripeWidthInches: number = 0.055; // Icon Founders Edition (type 92): the printed stripe's thickness; the two artist references show 4 px at 1280 (0.053-0.058")
    public static FoundersStripeClearanceInches: number = 0.3; // Icon Founders Edition (type 92): a stripe line stops this far outside a corner mark's square (the references end the lines 1.08-1.16" from the corner beside 1.6-1.7" marks)
    public static DimensionsPlusMat3WidthInches: number = 0.375; // Dimensions Plus (type 75): the third mat's band including its bevel (the product photos show about 0.30-0.33" of colour)
    public static DimensionsPlusRailAdderInches: number = 0.5; // Dimensions Plus (type 75): added to the top, side and bottom rail when the third mat is drawn, so the primary mat stays about as wide as on the photos (2.5-2.8")
    public static DefaultEPWidth: number = 3; // ****----____ EP-code-change ____----****'
    public static DefaultEPHeight: number = 2; // ****----____ EP-code-change ____----****'
    public static DefaultLinoID: number = 1564; // Cornell Gold industrial
    public static DefaultLinoWidthMax: number = 13;
    public static DefaultLinoHeightMax: number = 1.837;
    public static DefaultMaxFrameWidth: number = 550;
    public static DefaultMaxFrameHeight: number = 50000;
    public static DefaultMoulding: number = 158; // Gallery
    public static DefaultMouldingWidthMax: number = 2.375;
    public static DefaultPrimarymat: number = 337; // Black
    public static DefaultProductType: number = 3;
}
